import React from 'react'

import { reactionEventEmitter, reactionKeys } from 'helpers/events'
import { sendGiphy } from 'services/webSockets/reactions'

const useGiphy = (isLocal, identity) => {
    const [giphyData, setGiphyData] = React.useState({
        show: false,
        id: null,
    })

    React.useEffect(() => {
        let timeoutHandler

        const handler = ({ giphyId, sender }) => {
            // break early if its not local user and sender and identity uuid is not same
            if (!isLocal && sender !== identity.uuid) return

            if (
                (isLocal && !sender) ||
                (!isLocal && sender === identity.uuid)
            ) {
                setGiphyData({
                    show: true,
                    id: giphyId,
                })

                timeoutHandler = setTimeout(() => {
                    setGiphyData({
                        show: false,
                        id: null,
                    })
                }, 4000)
            }

            if (isLocal && !sender) {
                // broadcast websocket message
                sendGiphy(giphyId)
            }
        }

        reactionEventEmitter.addListener(reactionKeys.SHOW_GIPHY, handler)

        return () => {
            reactionEventEmitter.removeListener(
                reactionKeys.SHOW_GIPHY,
                handler
            )

            if (timeoutHandler) {
                clearTimeout(timeoutHandler)
            }
        }
    }, [])

    return giphyData
}

export { useGiphy }
